import { datapointIdToString, datapointRequestElementNameToString } from "./datapointHelper";
import { datasetNameToDatapointIdMap, DimensionsSelectionContext, inspectDataDefaultDimensions, defaultDimensions } from "./types";
import { DatapointIdStandardEnum } from "api/ux/src";
import { DashboardTypes } from "components/workspaces/hooks/types";
const selectDefaultDimensionsList = (selectionContext) => {
    switch (selectionContext) {
        case DimensionsSelectionContext.Default:
            return defaultDimensions;
        case DimensionsSelectionContext.InspectData:
            return inspectDataDefaultDimensions;
        default:
            return [];
    }
};
const getAllowedDimensionsByDatapointName = (datapointName, datapointAllowedDimensions) => datapointAllowedDimensions
    .find((d) => d.datapoint && datapointIdToString(d.datapoint) === datapointName)?.allowedDimensions;
const addDefaultDimensionsForMeasureToDimensionsList = (measureAllowedDimensions, defaultDimensionsList, dimensions) => {
    if (measureAllowedDimensions?.allowedDimensions) {
        const defaultAllowedDimensions = measureAllowedDimensions.allowedDimensions
            .filter((a) => a.standard && defaultDimensionsList.includes(a.standard));
        let found = false;
        for (const element of defaultDimensionsList) {
            if (defaultAllowedDimensions.some((d) => datapointIdToString(d) === element)) {
                if (!dimensions.some((d) => d === element)) {
                    dimensions.push(element.toString());
                }
                found = true;
            }
            if (found) {
                break;
            }
        }
    }
};
const pushDimensionFundIdTopToTheList = (dimensions) => {
    const fundIdIndex = dimensions.indexOf(DatapointIdStandardEnum.FundFundId);
    if (fundIdIndex !== -1) {
        dimensions.splice(fundIdIndex, 1);
        dimensions.unshift(DatapointIdStandardEnum.FundFundId);
    }
    return dimensions;
};
const getCommonDimensionToAllMeasures = (measures, defaultDimensionsList, datapointAllowedDimensions) => {
    for (const defaultDimension of defaultDimensionsList) {
        if (measures.every((m) => !m ||
            getAllowedDimensionsByDatapointName(m, datapointAllowedDimensions)?.some((d) => d.standard === defaultDimension))) {
            return defaultDimension;
        }
    }
    return null;
};
export const getDimensionsForMeasures = (measures, datapointContext, allowedDimensions, dimensionsSelectionContext = DimensionsSelectionContext.Default) => {
    const datasetDefaultDatapointId = datasetNameToDatapointIdMap.get(datapointContext), newDimensions = [];
    const defaultDimensionsList = selectDefaultDimensionsList(dimensionsSelectionContext);
    if (measures.every((m) => !m || allowedDimensions.find((d) => d.datapoint &&
        datapointIdToString(d.datapoint) === m)?.allowedDimensions?.some((d) => d.standard === datasetDefaultDatapointId)) &&
        !measures.every((m) => !m || allowedDimensions.find((d) => d.datapoint &&
            datapointIdToString(d.datapoint) === m)?.allowedDimensions?.some((d) => d.standard === DatapointIdStandardEnum.FundInvestorId)) &&
        !(measures.includes(DatapointIdStandardEnum.AssetAssetName) && !measures.includes(DatapointIdStandardEnum.FundFundName) && datapointContext === DashboardTypes.Fund)) {
        return datasetDefaultDatapointId ? [datasetDefaultDatapointId] : [];
    }
    const commonDimensionToAllMeasures = getCommonDimensionToAllMeasures(measures, defaultDimensionsList, allowedDimensions);
    if (commonDimensionToAllMeasures) {
        newDimensions.push(commonDimensionToAllMeasures);
    }
    else {
        measures.forEach((measure) => {
            const measureAllowedDimensions = allowedDimensions.find((d) => d.datapoint && datapointIdToString(d.datapoint) === measure);
            addDefaultDimensionsForMeasureToDimensionsList(measureAllowedDimensions || {}, defaultDimensionsList, newDimensions);
        });
    }
    if (measures.some((a) => a === DatapointIdStandardEnum.AssetAssetName) && !newDimensions.includes(DatapointIdStandardEnum.AssetAssetId)) {
        newDimensions.push(DatapointIdStandardEnum.AssetAssetId);
    }
    return pushDimensionFundIdTopToTheList(newDimensions);
};
const checkIfDimensionIsConfiguredForMeasure = (dimension, measure, allowedDimensions) => {
    if (!allowedDimensions) {
        return false;
    }
    return allowedDimensions.allowedDimensions?.some((a) => datapointIdToString(a) === dimension) ?? false;
};
const checkIfDimensionIsConfiguredForMeasures = (dimension, measures, allowedDimensions) => measures.every((m) => m === undefined ||
    checkIfDimensionIsConfiguredForMeasure(dimension, m, allowedDimensions.find((d) => d.datapoint && datapointIdToString(d.datapoint) === m)));
export const filterMeasuresAllowedDimensions = (measures, dimensions, allowedDimensions) => {
    const newDimensions = [];
    dimensions.forEach((d) => {
        if (checkIfDimensionIsConfiguredForMeasures(datapointRequestElementNameToString(d), measures, allowedDimensions)) {
            newDimensions.push(d);
        }
    });
    return newDimensions;
};
